import Vue from 'vue'
import VueRouter from 'vue-router'
import trackingService from '@/utils/tracking'

Vue.use(VueRouter)

const routes = [

  {
    path: '/chating',
    name: 'chating',
   component: () => import('../views/chatings/index.vue'),
  },
  // {
  //   path: '/demo',
  //   name: 'demo',
  //  component: () => import('../views/demo/index.vue'),
  // },
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index/index.vue'),
  },
  {
    path: '/hot-jobs',
    name: 'hot-jobs',
    component: () => import('../views/hot-jobs/index.vue')
  },
  {
    path: '/hot-companies',
    name: 'hot-companies',
    component: () => import('../views/hot-companies/index.vue')
  },
  {
    path: '/qzpp',
    name: 'qzpp',
    component: () => import('../views/qzpp/index.vue'),
  },
  {
    path: '/404',
    component: () => import('../views/404.vue'),
  },
  {
    path: '/store',
    component: () => import('../views/store.vue'),
    redirect: '/store/dashboard',
    children: [
      {
        path: 'entry',
        component: () => import('../views/entry/index.vue'),
        children: [
          { path: '', component: () => import('../views/entry/UnifiedEntry.vue') }
        ]
      },
      {
        path: 'dashboard',
        component: () => import('../views/dashboards/index.vue'),
        redirect: '/store/dashboard/profile',
        children: [
          {
            path: 'profile',
            component: () => import('../views/dashboards/profile/index.vue'),
          },
        ]
      },
      {
      path: 'personal',
      redirect: '/store/personal/basic',
      component: () => import('../views/personal/index.vue'), // 外层布局
      children: [
        { path: 'basic',    name: 'personalBasic',    component: () => import('../views/personal/basic/index.vue'),    meta: { title: '基本信息' } },
        { path: 'resume',   name: 'personalResume',   component: () => import('../views/personal/resume/index.vue'),   meta: { title: '简历管理' } },
        { path: 'security', name: 'personalSecurity', component: () => import('../views/personal/security/index.vue'), meta: { title: '账号安全' } },
        { path: 'privacy',  name: 'personalPrivacy',  component: () => import('../views/personal/privacy/index.vue'),  meta: { title: '隐私设置' } },
        { path: 'subscribe', name: 'personalSubscribe', component: () => import('../views/personal/subscribe/index.vue'), meta: { title: '订阅' } }
      ]
    },
      {
        path: '/Interview_Analysis/:id',
        name: 'Interview_Analysis',
        component: () => import('@/views/Interview_Analysis/index.vue')
      },

      {
        path: 'interview_ing',
        name: 'interview_ing',
        component: () => import('../views/interview_ing/index.vue')
      },
      {
        path: 'interview_ing_by_b',
        name: 'interview_ing_by_b',
        component: () => import('../views/interview_ing/interviewByB.vue')
      },
      {
        path: 'link-invalid',
        name: 'link_invalid',
        component: () => import('../views/link-invalid/index.vue')
      },
      {
        path: 'Interview_Analysis',
        component: () => import('../views/Interview_Analysis/index.vue'),
      },
    ]
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/dashboards/index.vue'),
  },
  {
    path: '/Interview_Analysis',
    name: 'Interview_Analysis',
    component: () => import('../views/Interview_Analysis/index.vue'),
  },

  {
    path: '/interview_ing',
    name: 'interview_ing',
    component: () => import('../views/interview_ing/index.vue')
  },
  {
    path: '/interview_ing_by_b',
    name: 'interview_ing_by_b',
    component: () => import('../views/interview_ing/interviewByB.vue')
  },
  {
    path: '/interview_mianshilishi',
    name: 'interview_mianshilishi',
    component: () => import('../views/interview_mianshilishi/index.vue')
  },
  {
    path: '/mbti-selection',
    name: 'mbti-selection',
    component: () => import('../views/mbti-selection/index.vue')
  },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404' }
]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  base: process.env.NODE_ENV === 'production' ? '' : '/',
  routes
})

// 全局路由错误处理
router.onError((error) => {
  console.error('路由错误:', error);
});

// 捕获导航重复错误
const originalPush = router.push;
if (originalPush) {
  router.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) {
      return originalPush.call(this, location, onResolve, onReject);
    }
    return originalPush.call(this, location).catch(err => {
      if (err.name !== 'NavigationDuplicated') {
        throw err;
      }
    });
  };
}

// 路由导航守卫 - 页面浏览埋点
router.afterEach((to, from) => {
  // 获取页面名称，优先使用路由的 name，其次使用 meta.title，最后使用路径
  const pageName = to.name || to.meta?.title || to.path || 'unknown'
  
  // 上报页面浏览事件
  trackingService.trackPageView(pageName, {
    route_name: to.name,
    route_path: to.path,
    route_full_path: to.fullPath,
    from_route: from.name || from.path,
    from_path: from.path
  })
})

export default router
